import { SET_YOUTUBE_PLAYLIST_DATA } from 'js/store/youtube/Youtube.actions.js';

import { parseData } from 'js/store/youtube/Youtube.parser.js';

const initState = { playlistIds: [], playlistById: {}, hasFetched: false };

const youtube = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case SET_YOUTUBE_PLAYLIST_DATA: {
      const { playlistById, playlistIds } = parseData(action.payload);
      nextState.playlistIds = playlistIds;
      nextState.playlistById = playlistById;
      nextState.hasFetched = true;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default youtube;
